import * as actionTypes from '../consts/actionTypes';

export interface IOverview {
    text: string;
    button: IButton;
    callAction: ICallAction;
}

export interface ICruiseInformation {
    text1: string;
    text2: string;
    companies: ICompanies[];
}

export interface IInsuranceOptions {
    headline: string;
    image: string;
    text1: string;
    text2: string;
    text3: string;
    button: IButton;
}

export interface IFaqs {
    items: IItems[];
}
export interface IItems {
    question: string;
    answer: string;
}
export interface ICallAction {
    text: string;
    phoneNumber: string;
    headline: string;
}
export interface ICompanies {
    title: string;
    url: string;
    data: { image: string; content: string; button: IButton };
}
export interface IButton {
    link: string;
    target: string;
    text?: string;
}

export interface ICovidCancellationPageReducer {
    overview: IOverview;
    cruiseInformation: ICruiseInformation;
    insuranceOptions: IInsuranceOptions;
    faqs: IFaqs;
}

export const initialState: ICovidCancellationPageReducer = {
    overview: {
        text: null,
        button: {
            link: null,
            target: null,
        },
        callAction: {
            text: null,
            phoneNumber: null,
            headline: null
        },
    },
    cruiseInformation: {
        text1: null,
        text2: null,
        companies: [],
    },
    insuranceOptions: {
        headline: null,
        image: null,
        text1: null,
        text2: null,
        text3: null,
        button: {
            link: null,
            target: null,
        },
    },
    faqs: {
        items: []
    },
};

export function covidCancellationPage(
    state: ICovidCancellationPageReducer = initialState,
    action,
): ICovidCancellationPageReducer {
    switch (action.type) {
        case actionTypes.loadCovidCancellationHubPageData:
            return { ...state, ...action.payload };
        case actionTypes.loadCovidCancellationHubCruiseLineData:
            return {
                ...state,
                cruiseInformation: {
                    text1: state.cruiseInformation.text1,
                    text2: state.cruiseInformation.text2,
                    companies: action.payload,
                },
            };
        default:
            return state;
    }
}
